<div>
  <mat-checkbox
    [(ngModel)]="withSecondBoard"
    (ngModelChange)="withSecondBoardChanged()"
    >Een tweede bord op hetzelfde pand (- {{ placementDiscount }} € op de
    plaatsing)</mat-checkbox
  >

  <ng-container *ngIf="withSecondBoard">
    <mat-card class="top-card mat-elevation-z0 secondary-border-color">
      <mat-radio-group
        class="flex-column"
        [value]="projectPlacement.secondBoard.secondBoardCopy"
        (change)="setSecondBoardCopy($event.value)"
      >
        <mat-radio-button [value]="true">
          Kopie van origineel besteld bord (zelfde plaatsingsmethode, titel,
          teksten, enz.)
        </mat-radio-button>
        <mat-radio-button [value]="false">
          Ander opmaak van het bord, klik hier
        </mat-radio-button>
      </mat-radio-group>
      <div
        *ngIf="projectPlacement.secondBoard.secondBoardCopy === false"
        class="upper-space"
      >
        <textarea-input
          [title]="'Info omtrent de configuratie van dit bord'"
          [initContent]="projectPlacement.secondBoard.secondBoardConfiguration"
          [placeholder]="''"
          [client]="client"
          [sensitive]="true"
          (answer)="secondBoardConfigurationChanged($event)"
        ></textarea-input>
      </div>
      <div class="upper-space">
        <textarea-input
          [title]="'Info omtrent de plaatsing van dit bord'"
          [initContent]="projectPlacement.secondBoard.secondBoardPlacementInfo"
          [placeholder]="''"
          [client]="client"
          [sensitive]="true"
          (answer)="secondBoardPlacementInfoChanged($event)"
        ></textarea-input>
      </div>
    </mat-card>
  </ng-container>
</div>
